import { Fragment, memo } from 'react';
import EditData from './edit-data';
import Marriage from './marriage';
import CivilStatus from './civil-status';
import CancelMarriage from './cancel-marriage';
import AccordionPerson from 'shell/components/shared/person';

const FormCancelMarriageComponent = (): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <Marriage disabled />
      <CivilStatus disabled />
      <CancelMarriage />
    </Fragment>
  );
};

FormCancelMarriageComponent.displayName = 'Form Cancel Marriage';

const FormCancelMarriage = memo(FormCancelMarriageComponent);

export default FormCancelMarriage;
